<template>
  <div class="home-title">
    <p class="title">{{ title }}</p>
    <p class="desc">{{ desc }}</p>
  </div>
</template>

<script>
export default {
  props: ['title', 'desc'],
};
</script>

<style lang="less" scoped>
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.home-title {
  text-align: center;
  margin-bottom: 56px;
  .title {
    .font-regular;
    height: 32px;
    font-size: 26px;
    font-weight: 400;
    color: @app-color;
    line-height: 32px;
  }
  .desc {
    .font-light;
    font-size: 16px;
    font-weight: 300;
    color: @app-body-color;
    padding-top: 5px;
    line-height: 20px;
  }
}
</style>
